import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, withRouter, Redirect } from 'react-router-dom';

import { authOperations } from '../redux/auth';
import { configOperations } from '../redux/config';

import Header from './Header';
import DispatchesPage from './dispatches/DispatchesPage';
import dispatchMap from './dispatchMap';
import IncidentsPage from './incidents/IncidentsPage';
import Terms from './Terms';
import AccessDenied from './AccessDenied';
import DashboardPage from "./dashboards/DashboardPage";

class Main extends Component {
  constructor(props) {
    super(props);

    let redirect = false;

    if (this.props.location.pathname === '/') {
      redirect = true;
    }

    this.state = {
      termsAccepted: window.localStorage.getItem('termsAccepted'),
      redirect
    };
  }

  componentWillMount() {
    // Set some API properties
    window.api.setAuth(this.props.auth.user);
    window.api.setPortalUrl(this.props.appConfig.portalUrl);

    // Fetch user settings
    this.props.initUserPrefs();
  }

  handleTermsAccepted = () => {
    window.localStorage.setItem('termsAccepted', 'true');
    this.setState({ termsAccepted: true });
  };

  render() {
    const authorized = this.props.auth.user.isAuthorized;
    const termsAccepted = this.state.termsAccepted;

    let accessDeniedDialog;
    if (!authorized) {
      accessDeniedDialog = <AccessDenied user={this.props.auth.user} />;
    }

    let termsDialog;
    if (authorized && !termsAccepted) {
      termsDialog = <Terms handleAccept={this.handleTermsAccepted} />;
    }

    return (
      <div className="App">
        <Header />
        <div className="app-content">
          {termsDialog}
          {accessDeniedDialog}
          <Route path="/" exact component={IncidentsPage} />
          <Route path="/incidents" component={IncidentsPage} />
          <Route path="/dispatches" component={DispatchesPage} />
          <Route path="/dispatchmap" component={dispatchMap} />
          <Route path="/dashboards" component={DashboardPage} />

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...authOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main)
);



// WEBPACK FOOTER //
// ./src/components/Main.js